import Lottie from 'lottie-react';

import faceTalkingElated from '../jsons/Face_Talking_Elated.json';

const FaceTalkingElated = props => {
  return <Lottie animationData={faceTalkingElated} {...props} />;
};

export default FaceTalkingElated;
